/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Optional range constraint, for numeric properties
 * @export
 * @interface Range
 */
export interface Range {
    /**
     * 
     * @type {boolean}
     * @memberof Range
     */
    asAbsValue?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Range
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof Range
     */
    min?: number;
}

/**
 * Check if a given object implements the Range interface.
 */
export function instanceOfRange(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RangeFromJSON(json: any): Range {
    return RangeFromJSONTyped(json, false);
}

export function RangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Range {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asAbsValue': !exists(json, 'asAbsValue') ? undefined : json['asAbsValue'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'min': !exists(json, 'min') ? undefined : json['min'],
    };
}

export function RangeToJSON(value?: Range | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asAbsValue': value.asAbsValue,
        'max': value.max,
        'min': value.min,
    };
}

